<kendo-formfield showHint="initial" showErrors="initial" [formGroup]="formGroup">
  <kendo-label [text]="data.key | i18nMetadata"></kendo-label>
  <kendo-numerictextbox [title]="data.key | i18nMetadata" [placeholder]="placeholder" [formControlName]="data.key + data.valueType" [min]="settings.min" [max]="settings.max"></kendo-numerictextbox>
  <kendo-formhint>{{ 'circ_template_formhint_number' | i18n }}</kendo-formhint>
  <kendo-formerror>
    <ng-container *ngIf="formGroup.controls[data.key + data.valueType].errors as err">
      <div *ngIf="err.minError || err.maxError">{{ 'circ_template_formerror_min_max' | i18n }}</div>
      <div *ngIf="err.required">{{ 'circ_metadata_formerror_required' | i18n }}</div>
    </ng-container>
  </kendo-formerror>
</kendo-formfield>
